<template
  ><div>
    <v-btn
      @click.stop="clickHandler"
      :class="styles"
      fab
      small
      color="white"
      class="button"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div></template
>

<script>
import { showLabelOnHover } from '@/components/Shared/Button/iconButtonStyles'
export default {
  name: 'AppPopupCloseButton',
  computed: {
    styles() {
      return showLabelOnHover('閉じる', { left: 30 })
    },
  },
  methods: {
    clickHandler() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
.button {
  width: 30px;
  height: 30px;
}
</style>
